module.exports = __webpack_public_path__ + "static/key-driftland-f6296d40fe563b5705301f8d516e6415.webp";